import * as angular from 'angular';
import * as Models from '../../models/';
import * as Enum from '../../models/enum';

import { IDateRangeService } from '../general/dateRange.service';
import { IRequestService } from '../request.service';

export interface IinputValuesStatusService {
    getTagStatusesBetweenDates(guid: string,
        type: string,
        beginDate: string,
        endDate: string,
        force?: boolean): angular.IPromise<any>;
    getMissingBetweenDates(guid: string, type: any, beginDate: string, endDate: string): angular.IPromise<any>;
    getMissingListBetweenDates(list: Models.KeyValuePair<string, Enum.SelectorType>[],
        beginDate: string,
        endDate: string): angular.IPromise<Models.KeyValuePair<string, string[]>[]>;
    getPercentageBadValuesPerTag(force?: boolean): angular.IPromise<any>;
}


export class InputValuesStatusService implements IinputValuesStatusService {
    static serviceId = 'inputValuesStatusService';
    static $inject = ['$q', 'dateRangeService', 'requestService'];
    static controllerUrl = 'InputValuesStatus';
    static missingUrl = `${InputValuesStatusService.controllerUrl}/missing`;
    static badValuesMethod = 'getPercentageBadValuesPerTag';

    constructor(private _$q: angular.IQService,
        private _dateRangeService: IDateRangeService,
        private _requestService: IRequestService) {
    }

    getTagStatusesBetweenDates(guid: string,
        type: string,
        beginDate: string,
        endDate: string,
        force: boolean = false): angular.IPromise<any> {
        const url = `${InputValuesStatusService.controllerUrl}/${type}`;
        const params = {
            guid: guid,
            beginDateTime: beginDate,
            endDateTime: endDate
        };
        if (force) {
            this._requestService.cleanCacheAtV1(url, params);
        }
        return this._requestService.getAtV1(url, params);
    }

    getMissingBetweenDates(guid: string, type: any, beginDate: string, endDate: string): angular.IPromise<any> {
        const params = {
            guid: guid,
            type: type,
            beginDateTime: beginDate,
            endDateTime: endDate
        };

        return this._requestService.getAtV1(InputValuesStatusService.missingUrl, params);
    }

    getMissingListBetweenDates(list: Models.KeyValuePair<string, Models.SelectorType>[],
        beginDate: string,
        endDate: string): angular.IPromise<Models.KeyValuePair<string, string[]>[]> {
        const params = {
            beginDateTime: beginDate,
            endDateTime: endDate
        };

        return this._requestService.postAtV1(InputValuesStatusService.missingUrl, list, params);
    }

    getPercentageBadValuesPerTag(force: boolean = false): angular.IPromise<any> {
        if (this._dateRangeService.initialized()) {
            return this.getAtAddress(InputValuesStatusService.badValuesMethod);
        } else {
            const defered = this._$q.defer();
            defered.resolve([]);
            return defered.promise;
        }
    }

    private getUrl(method: string, beginDate: string, endDate: string, guid?: string) {
        const url = `${InputValuesStatusService.controllerUrl}/${method}?`
            + (guid ? (`groupGuid=${guid}&`) : '')
            + 'beginDate=' + beginDate
            + '&endDate=' + endDate;
        return url;
    }

    private getAtAddress(method: string, guid?: string): angular.IPromise<any> {
        const beginDate = this._dateRangeService.beginDate() as string;
        const endDate = this._dateRangeService.endDate() as string;
        return this.getAtAddressBetweenDates(method, beginDate, endDate, guid);
    }

    private getAtAddressBetweenDates(method: string,
        beginDate: string,
        endDate: string,
        guid?: string): angular.IPromise<any> {
        if (beginDate && endDate) {
            const url = this.getUrl(method, beginDate, endDate, guid);
            return this._requestService.getAtV1(url);
        } else {
            const defered = this._$q.defer();
            defered.resolve(0);
            return defered.promise;
        }
    }
}